
import { useContext } from "react";

import './formBuilderCart.css';
import FormBuilderCartContext from "./formBuilderCartContext";
import { Link } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPlus } from "@fortawesome/free-solid-svg-icons";

export default function FormBuilderCart() {
    const { formBuilderCart, newCartItems, removeNewCartItems } = useContext(FormBuilderCartContext);

    return (
        <>
            {
                formBuilderCart.length > 0 && 
                <div className="fb-cart-block">
                    <div className="fb-cart-link"><Link to="/form-builder"><strong>Form Builder Cart ({formBuilderCart.length})</strong></Link></div>
                    {newCartItems.length > 0 && 
                    <button onClick={e => removeNewCartItems()}>
                        <FontAwesomeIcon icon={faPlus} />{" "}Undo Add
                    </button>}
                </div>
            }
        </>
    );
}